"use client";

import React, { useState } from "react";
import { Swiper as SwiperReact, SwiperSlide } from "swiper/react";
import { FreeMode, Thumbs } from "swiper/modules";

const ProductImg = ({ image }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  return (
    <>
      <SwiperReact
        loop={true}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[FreeMode, Thumbs]}
        className="product-details-image"
      >
        <SwiperSlide>
          <img
            src={image}
            alt="product1"
            width={300}
            height={286}
            style={{ borderRadius: "7px" }}
          />
        </SwiperSlide>
      </SwiperReact>
    </>
  );
};

export default ProductImg;
